export default __webpack_public_path__ + "static/media/up_icons.64b30ad5.svg";